import i18next from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import backend from 'i18next-fetch-backend';
import { initReactI18next } from 'react-i18next';
import { i18nextConfig } from './i18next.config';
i18next.use(backend)
    .use(LanguageDetector)
    .use(initReactI18next)
    .init(i18nextConfig);
